const SELECTOR = '#legalDocumentsForm';
const SELECTOR_TYPE = '.documents-type';

const legalDocuments = {
  init() {
    this.legalDocumentsForm = document.querySelector(SELECTOR);
    this.documentsType = document.querySelector(SELECTOR_TYPE);
    if (!this.legalDocumentsForm) {
      return;
    }
    legalDocuments.bindEvents();
  },
  bindEvents() {
    this.legalDocumentsForm.addEventListener('jb-button:clicked', async (e) => {
      this.documentsType.value = e.detail.name;
      if (e.detail.name === 'documents') {
        this.legalDocumentsForm.submit();
      } else if (e.detail.name === 'close_prices') {
        this.legalDocumentsForm.submit();
      }
    });
  },
};

export default legalDocuments;
